import { render, staticRenderFns } from "./MemberCenterAdminUserComments.vue?vue&type=template&id=577fc4c9&scoped=true&lang=pug&"
import script from "./MemberCenterAdminUserComments.vue?vue&type=script&lang=js&"
export * from "./MemberCenterAdminUserComments.vue?vue&type=script&lang=js&"
import style0 from "./MemberCenterAdminUserComments.vue?vue&type=style&index=0&id=577fc4c9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577fc4c9",
  null
  
)

export default component.exports